// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import {
//   Table,
//   Container,
//   Card,
//   Pagination,
//   Badge,
//   Button,
//   InputGroup,
//   Form,
//   Row,
//   Col,
// } from "react-bootstrap";
// import { BsEye } from "react-icons/bs";
// import {
//   FaTimes,
//   FaStar,
//   FaCheck,
//   FaCheckCircle,
//   FaTimesCircle,
// } from "react-icons/fa";
// import { jsPDF } from "jspdf";
// import html2canvas from "html2canvas";
// import "./ServitorFeedbackList.css";
// import { URL } from "../../../config";

// const ServitorFeedbackList = () => {
//   const [servitors, setServitors] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [servitorFilter, setServitorFilter] = useState("");

//   const [filteredServitors, setFilteredServitors] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [selectedServitor, setSelectedServitor] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [filterService, setFilterService] = useState("All");
//   const [error, setError] = useState(null);
//   const modalRef = useRef(null);
//   const tableRef = useRef(null);
//   const itemsPerPage = 10;

//   useEffect(() => {
//     const fetchServitors = async () => {
//       try {
//         const { data } = await axios.get(
//           `${URL}/admin/servitors/metrics`,
//           {
//             params: {
//               search: searchTerm,
//               filter: servitorFilter,
//             },
//           }
//         );
//         setServitors(data);
//         setError(null);
//         setCurrentPage(1);
//       } catch (err) {
//         console.error("Error fetching servitor metrics:", err);
//         setError("Failed to load servitor data. Please try again later.");
//       }
//     };
//     fetchServitors();
//   }, [searchTerm, servitorFilter]);

//   const handleViewFeedbacks = (servitor) => {
//     setSelectedServitor(servitor);
//     setShowModal(true);
//     document.body.style.overflow = "hidden";
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedServitor(null);
//     document.body.style.overflow = "auto";
//   };

//   useEffect(() => {
//     const node = modalRef.current;
//     const handleBackdropClick = (e) => {
//       if (node && e.target === node) {
//         handleCloseModal();
//       }
//     };

//     const handleEscapeKey = (e) => {
//       if (e.key === "Escape") {
//         handleCloseModal();
//       }
//     };

//     if (node) {
//       node.addEventListener("click", handleBackdropClick);
//     }
//     document.addEventListener("keydown", handleEscapeKey);

//     return () => {
//       if (node) {
//         node.removeEventListener("click", handleBackdropClick);
//       }
//       document.removeEventListener("keydown", handleEscapeKey);
//     };
//   }, []);

//   useEffect(() => {
//     let results = servitors;
//     if (filterService !== "All") {
//       results = results.filter(
//         (servitor) => servitor.service === filterService
//       );
//     }

//     setFilteredServitors(results);
//     setCurrentPage(1);
//   }, [filterService, servitors]);

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredServitors.slice(
//     indexOfFirstItem,
//     indexOfLastItem
//   );
//   const totalPages = Math.ceil(filteredServitors.length / itemsPerPage);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const getPageItems = (total, current, maxButtons = 7) => {
//     const pages = [];
//     pages.push(1);
//     const siblings = Math.floor((maxButtons - 3) / 2);
//     let start = Math.max(2, current - siblings);
//     let end = Math.min(total - 1, current + siblings);

//     if (current <= siblings + 2) {
//       end = Math.min(total - 1, maxButtons - 1);
//     }
//     if (current >= total - (siblings + 1)) {
//       start = Math.max(2, total - (maxButtons - 2));
//     }

//     if (start > 2) {
//       pages.push("start-ellipsis");
//     }

//     for (let i = start; i <= end; i++) {
//       pages.push(i);
//     }

//     if (end < total - 1) {
//       pages.push("end-ellipsis");
//     }

//     if (total > 1) {
//       pages.push(total);
//     }

//     return pages;
//   };

//   const formatDateTime = (iso) => {
//     const d = new Date(iso);
//     const dateStr = d.toLocaleDateString("en-US", {
//       day: "numeric",
//       month: "long",
//       year: "numeric",
//     }); // "July 7, 2025"
//     // swap to "7-July-2025"
//     const [month, day, year] = dateStr.replace(",", "").split(" ");
//     const datePart = `${day}-${month}-${year}`;
//     const timeStr = d
//       .toLocaleTimeString("en-US", {
//         hour: "numeric",
//         minute: "2-digit",
//         second: "2-digit",
//         hour12: true,
//       })
//       .toLowerCase();
//     return `${datePart}, ${timeStr}`;
//   };

//   const generatePDF = async () => {
//     const doc = new jsPDF();

//     // Add title
//     doc.setFontSize(18);
//     doc.setFont("helvetica", "bold");
//     doc.text(`Servitor Report - ${filterService || "All Services"}`, 14, 20);

//     // Add timestamp
//     doc.setFontSize(10);
//     doc.setFont("helvetica", "normal");
//     const date = new Date().toLocaleString("en-US", {
//       day: "numeric",
//       month: "long",
//       year: "numeric",
//       hour: "numeric",
//       minute: "2-digit",
//       second: "2-digit",
//       hour12: true,
//     });
//     doc.text(`Generated on: ${date}`, 14, 30);

//     // Create a hidden table for PDF rendering
//     const hiddenTable = document.createElement("div");
//     hiddenTable.style.position = "absolute";
//     hiddenTable.style.left = "-9999px";
//     hiddenTable.innerHTML = `
//     <table class="adminServitorFeedbacks-table" style="width: 100%; border-collapse: collapse;">
//       <thead>
//         <tr>
//           <th>ID</th>
//           <th>Servitor Name</th>
//           <th>Mobile</th>
//           <th>Avg Rating</th>
//           <th>Commission</th>
//           <th>Complete Orders</th>
//           <th>Accepted Orders</th>
//           <th>Penalty</th>
//           <th>Order Cancelled</th>
//         </tr>
//       </thead>
//       <tbody>
//         ${filteredServitors
//           .map(
//             (servitor) => `
//           <tr>
//             <td>${servitor.id || "-"}</td>
//             <td>${servitor.name || "-"}</td>
//             <td>0${servitor.mobile || "-"}</td>
//             <td>${servitor.rating ? servitor.rating.toFixed(1) : "0"} / 5</td>
//             <td>${servitor.commissionSum || 0}Tk</td>
//             <td>${servitor.ordersCompleted || 0}</td>
//             <td>${servitor.ordersAccepted || 0}</td>
//             <td>0</td>
//             <td>${servitor.ordersCancelledByServitor || 0}</td>
//           </tr>
//         `
//           )
//           .join("")}
//       </tbody>
//     </table>
//   `;
//     document.body.appendChild(hiddenTable);

//     // Capture table as image
//     const canvas = await html2canvas(hiddenTable, { scale: 2 });
//     const imgData = canvas.toDataURL("image/png");

//     // Calculate image dimensions
//     const imgWidth = 180; // Width in mm
//     const pageHeight = 295; // A4 height in mm
//     const imgHeight = (canvas.height * imgWidth) / canvas.width;
//     let heightLeft = imgHeight;
//     let position = 40;

//     // Add image to PDF
//     doc.addImage(imgData, "PNG", 15, position, imgWidth, imgHeight);
//     heightLeft -= pageHeight - 40;

//     // Handle multi-page if table is long
//     while (heightLeft > 0) {
//       doc.addPage();
//       position = heightLeft - imgHeight + 20;
//       doc.addImage(imgData, "PNG", 15, 20, imgWidth, imgHeight);
//       heightLeft -= pageHeight - 20;
//     }

//     // Clean up
//     document.body.removeChild(hiddenTable);

//     // Save the PDF
//     doc.save(
//       `Servitor_Report_${filterService || "All"}_${
//         new Date().toISOString().split("T")[0]
//       }.pdf`
//     );
//   };

//   const renderFeedbackDetails = () => {
//     if (!selectedServitor) return null;

//     const {
//       rating,
//       ratingCount,
//       ordersCompleted,
//       ordersAccepted,
//       ordersCancelledByServitor,
//       totalEarnings,
//       commissionSum,
//       rechargeSum,
//       penaltySum,
//       feedbacks,
//     } = selectedServitor;

//     return (
//       <div className="adminServitorFeedbacks-modal">
//         <div className="adminServitorFeedbacks-modal-header">
//           <button
//             className="adminServitorFeedbacks-modal-close"
//             onClick={handleCloseModal}
//           >
//             <FaTimes size={20} />
//           </button>
//           <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
//             <div className="adminServitorFeedbacks-service-icon">
//               {selectedServitor.service === "Electrician" && (
//                 <FaStar style={{ color: "#f59e0b" }} />
//               )}
//               {selectedServitor.service === "Home Cleaning" && (
//                 <FaStar style={{ color: "#f59e0b" }} />
//               )}
//               {selectedServitor.service === "Plumber" && (
//                 <FaStar style={{ color: "#f59e0b" }} />
//               )}
//             </div>
//             <div>
//               <h2 className="adminServitorFeedbacks-modal-title">
//                 Feedback for - {selectedServitor.name}
//               </h2>
//               <p className="adminServitorFeedbacks-modal-subtitle">
//                 {selectedServitor.service} • {ratingCount || 0} Feedbacks
//               </p>
//             </div>
//           </div>
//         </div>

//         <div className="adminServitorFeedbacks-modal-body">
//           <div className="adminServitorFeedbacks-summary-cards">
//             <div className="adminServitorFeedbacks-summary-card adminServitorFeedbacks-rating-card">
//               <div>
//                 <p className="adminServitorFeedbacks-detail-text">
//                   Average Rating
//                 </p>
//                 <p className="adminServitorFeedbacks-rating-value">
//                   {rating ? rating.toFixed(1) : 0} / 5
//                 </p>
//                 <div className="adminServitorFeedbacks-star-container">
//                   {[...Array(5)].map((_, index) => (
//                     <FaStar
//                       key={index}
//                       size={20}
//                       style={{
//                         color:
//                           index < Math.round(rating || 0)
//                             ? "#f59e0b"
//                             : "#e5e7eb",
//                       }}
//                     />
//                   ))}
//                 </div>
//               </div>
//             </div>
//             {/* <div className="adminServitorFeedbacks-summary-card adminServitorFeedbacks-count-card">
//               <div>
//                 <p className="adminServitorFeedbacks-detail-text">Total Feedbacks</p>
//                 <p className="adminServitorFeedbacks-count-value">{ratingCount || 0}</p>
//               </div>
//               <FaStar size={24} style={{ color: "#7c3aed" }} />
//             </div> */}
//             <div className="adminServitorFeedbacks-summary-card adminServitorFeedbacks-completed-card">
//               <div>
//                 <p className="adminServitorFeedbacks-detail-text">
//                   Orders Completed
//                 </p>
//                 <p className="adminServitorFeedbacks-count-value">
//                   {ordersCompleted || 0}
//                 </p>
//               </div>
//               <FaCheckCircle size={24} style={{ color: "#22c55e" }} />
//             </div>
//             <div className="adminServitorFeedbacks-summary-card adminServitorFeedbacks-accepted-card">
//               <div>
//                 <p className="adminServitorFeedbacks-detail-text">
//                   Orders Accepted
//                 </p>
//                 <p className="adminServitorFeedbacks-count-value">
//                   {ordersAccepted || 0}
//                 </p>
//               </div>
//               <FaCheckCircle size={24} style={{ color: "#10b981" }} />
//             </div>
//             <div className="adminServitorFeedbacks-summary-card adminServitorFeedbacks-cancelled-card">
//               <div>
//                 <p className="adminServitorFeedbacks-detail-text">
//                   Orders Cancelled
//                 </p>
//                 <p className="adminServitorFeedbacks-count-value">
//                   {ordersCancelledByServitor || 0}
//                 </p>
//               </div>
//               <FaTimesCircle size={24} style={{ color: "#ef4444" }} />
//             </div>
//             <div className="adminServitorFeedbacks-summary-card adminServitorFeedbacks-earnings-card">
//               <div>
//                 <p className="adminServitorFeedbacks-detail-text">
//                   Total Earnings
//                 </p>
//                 <p className="adminServitorFeedbacks-price-value">
//                   ৳{totalEarnings || 0}
//                 </p>
//               </div>
//               {/* <FaDollarSign size={24} style={{ color: "#2563eb" }} /> */}
//             </div>
//             <div className="adminServitorFeedbacks-summary-card adminServitorFeedbacks-commission-card">
//               <div>
//                 <p className="adminServitorFeedbacks-detail-text">Commission</p>
//                 <p className="adminServitorFeedbacks-price-value">
//                   ৳{commissionSum || 0}
//                 </p>
//               </div>
//               {/* <FaDollarSign size={24} style={{ color: "#2563eb" }} /> */}
//             </div>
//             <div className="adminServitorFeedbacks-summary-card adminServitorFeedbacks-recharge-card">
//               <div>
//                 <p className="adminServitorFeedbacks-detail-text">
//                   Recharge Amount
//                 </p>
//                 <p className="adminServitorFeedbacks-price-value">
//                   ৳{rechargeSum || 0}
//                 </p>
//               </div>
//               {/* <FaDollarSign size={24} style={{ color: "#2563eb" }} /> */}
//             </div>
//             <div className="adminServitorFeedbacks-summary-card adminServitorFeedbacks-penalty-card">
//               <div>
//                 <p className="adminServitorFeedbacks-detail-text">Penalties</p>
//                 <p className="adminServitorFeedbacks-count-value"> ৳{penaltySum || 0}</p>
//               </div>
//               <FaTimesCircle size={24} style={{ color: "#ef4444" }} />
//             </div>
//           </div>

//           <div className="adminServitorFeedbacks-detail-card">
//             <h3 className="adminServitorFeedbacks-detail-title">
//               <FaStar style={{ marginRight: "8px", color: "#f59e0b" }} />
//               Feedback List
//             </h3>
//             <div className="adminServitorFeedbacks-feedback-list">
//               {feedbacks.length === 0 ? (
//                 <p className="adminServitorFeedbacks-detail-value">
//                   No feedback available.
//                 </p>
//               ) : (
//                 feedbacks.map((feedback) => (
//                   <div
//                     key={feedback.order_number}
//                     className="adminServitorFeedbacks-feedback-item"
//                   >
//                     <div className="adminServitorFeedbacks-feedback-header">
//                       <span className="adminServitorFeedbacks-feedback-id">
//                         Feedback of order #{feedback.order_number}
//                       </span>
//                     </div>
//                     <div className="adminServitorFeedbacks-feedback-rating">
//                       <span>Rating:</span>
//                       <div className="adminServitorFeedbacks-star-container">
//                         {[...Array(5)].map((_, index) => (
//                           <FaStar
//                             key={index}
//                             size={16}
//                             style={{
//                               color:
//                                 index < feedback.rating ? "#f59e0b" : "#e5e7eb",
//                             }}
//                           />
//                         ))}
//                       </div>
//                     </div>
//                     <p className="adminServitorFeedbacks-feedback-comment">
//                       {feedback.feedback}
//                     </p>
//                     <p className="adminServitorFeedbacks-feedback-date">
//                       {/* Submitted:{" "} */}
//                       {/* {new Date(feedback.transactionDate).toLocaleString()} */}
//                       {formatDateTime(feedback.transactionDate)}
//                     </p>
//                     <hr className="adminServitorFeedbacks-rating-underline" />
//                   </div>
//                 ))
//               )}
//             </div>
//           </div>
//         </div>

//         <div className="adminServitorFeedbacks-modal-footer">
//           <div className="adminServitorFeedbacks-footer-buttons">
//             <button
//               className="adminServitorFeedbacks-footer-btn adminServitorFeedbacks-footer-btn-close"
//               onClick={handleCloseModal}
//             >
//               <FaCheck />
//               Close
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <Container fluid className="adminServitorFeedbacks-container">
//       <Card className="adminServitorFeedbacks-card">
//         <Card.Body>
//           {/* <Card.Title className="adminServitorFeedbacks-title">
//             Servitor Feedbacks & Details
//           </Card.Title> */}

//           <Card.Header className="adminServitorFeedbacks-header">
//             <h4 className="adminServitorFeedbacks-title">
//               Servitor Feedbacks & Details
//             </h4>
//           </Card.Header>

//           {error && <div className="adminServitorFeedbacks-error">{error}</div>}

//           <Row className="mb-3">
//             <Col md={8}>
//               <InputGroup>
//                 <Form.Control
//                   type="text"
//                   placeholder="Search by Servitor ID or Mobile (Search mobile no Start without 0)"
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   className="adminServitorFeedbacks-search"
//                 />
//               </InputGroup>
//             </Col>
//             <Col md={4}>
//               <Form.Group controlId="serviceFilter">
//                 <Form.Select
//                   value={servitorFilter}
//                   onChange={(e) => setServitorFilter(e.target.value)}
//                   className="adminServitorFeedbacks-filter-select"
//                 >
//                   <option value="">— Filter Servitors —</option>
//                   <option value="mostCommission">Most Commission</option>
//                   <option value="topRating">Top Rating</option>
//                   <option value="lowestCommission">Lowest Commission</option>
//                   <option value="lowRating">Low Rating</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>

//           <div className="adminServitorFeedbacks-filter-container">
//             <div className="adminServitorFeedbacks-service-filters">
//               {["All", "Electrician", "Home Cleaning", "Plumber"].map(
//                 (service) => (
//                   <Button
//                     key={service}
//                     variant={
//                       filterService === service ? "primary" : "outline-primary"
//                     }
//                     className="adminServitorFeedbacks-filter-btn"
//                     onClick={() => setFilterService(service)}
//                   >
//                     {service}
//                   </Button>
//                 )
//               )}
//             </div>

//             <div className="adminServitorFeedbacks-export-container">
//               <button
//                 onClick={generatePDF}
//                 className="adminServitorFeedbacks-footer-btn adminServitorFeedbacks-export-btn"
//               >
//                 <FaCheck />
//                 Export to PDF
//               </button>
//             </div>
//           </div>

//           <Table
//             striped
//             bordered
//             hover
//             responsive
//             className="adminServitorFeedbacks-table"
//             ref={tableRef}
//           >
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Servitor ID</th>
//                 <th>Mobile</th>
//                 <th>Name</th>
//                 <th>Service</th>
//                 <th>Avg Rating</th>
//                 {/* <th>Orders Completed</th> */}
//                 {/* <th>Orders Accepted</th> */}
//                 {/* <th>Orders Cancelled</th> */}
//                 {/* <th>Total Earnings</th> */}
//                 <th>Commission</th>
//                 {/* <th>Recharge Amount</th> */}
//                 {/* <th>Penalties</th> */}
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentItems.map((servitor, index) => (
//                 <tr key={servitor.id}>
//                   <td>{index + 1 + indexOfFirstItem}</td>
//                   <td>{servitor.id}</td>
//                   <td>{servitor.mobile}</td>
//                   <td>{servitor.name}</td>
//                   <td>{servitor.service}</td>
//                   <td>
//                     <Badge className="adminServitorFeedbacks-rating-badge">
//                       {servitor.rating ? servitor.rating.toFixed(1) : 0} / 5
//                       <div className="adminServitorFeedbacks-star-container">
//                         {[...Array(5)].map((_, idx) => (
//                           <FaStar
//                             key={idx}
//                             size={14}
//                             style={{
//                               color:
//                                 idx < Math.round(servitor.rating || 0)
//                                   ? "#f59e0b"
//                                   : "#e5e7eb",
//                             }}
//                           />
//                         ))}
//                       </div>
//                     </Badge>
//                   </td>
//                   {/* <td>{servitor.ordersCompleted || 0}</td> */}
//                   {/* <td>{servitor.ordersAccepted || 0}</td> */}
//                   {/* <td>{servitor.ordersCancelledByServitor || 0}</td> */}
//                   {/* <td>৳{servitor.totalEarnings || 0}</td> */}
//                   <td>৳{servitor.commissionSum || 0}</td>
//                   {/* <td>৳{servitor.rechargeSum || 0}</td> */}
//                   {/* <td>0</td> */}
//                   <td>
//                     <Button
//                       variant="outline-primary"
//                       size="sm"
//                       className="adminServitorFeedbacks-action-btn"
//                       onClick={() => handleViewFeedbacks(servitor)}
//                     >
//                       <BsEye size={16} />
//                     </Button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>

//           <Pagination>
//             <Pagination.First
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//             />
//             <Pagination.Prev
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//             />
//             {getPageItems(totalPages, currentPage).map((item, idx) => {
//               if (item === "start-ellipsis" || item === "end-ellipsis") {
//                 return <Pagination.Ellipsis key={item + idx} disabled />;
//               }
//               return (
//                 <Pagination.Item
//                   key={item}
//                   active={item === currentPage}
//                   onClick={() => handlePageChange(item)}
//                 >
//                   {item}
//                 </Pagination.Item>
//               );
//             })}
//             <Pagination.Next
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//             />
//             <Pagination.Last
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//             />
//           </Pagination>
//         </Card.Body>
//       </Card>

//       {showModal && (
//         <div className="adminServitorFeedbacks-modal-backdrop" ref={modalRef}>
//           {renderFeedbackDetails()}
//         </div>
//       )}
//     </Container>
//   );
// };

// export default ServitorFeedbackList;








// ***** Updated with Paginations search filter (19-Oct-2025) ***** //
// ServitorFeedbackList.jsx
// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import {
//   Table,
//   Container,
//   Card,
//   Pagination,
//   Badge,
//   Button,
//   InputGroup,
//   Form,
//   Row,
//   Col,
// } from "react-bootstrap";
// import { BsEye } from "react-icons/bs";
// import { FaTimes, FaStar, FaCheck, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
// import { jsPDF } from "jspdf";
// import html2canvas from "html2canvas";
// import "./ServitorFeedbackList.css";
// import { URL } from "../../../config";

// const DEFAULT_LIMIT = 10;

// const ServitorFeedbackList = () => {
//   // server data
//   const [servitors, setServitors] = useState([]);
//   const [meta, setMeta] = useState({
//     page: 1,
//     limit: DEFAULT_LIMIT,
//     total: 0,
//     totalPages: 1,
//     search: "",
//     serviceType: "All",
//     sortBy: "id",
//     sortDir: "ASC",
//   });

//   // ui state
//   const [searchTerm, setSearchTerm] = useState("");
//   const [servitorFilter, setServitorFilter] = useState(""); // mostCommission | topRating | lowestCommission | lowRating
//   const [filterService, setFilterService] = useState("All");

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   // modal
//   const [selectedServitor, setSelectedServitor] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const modalRef = useRef(null);
//   const tableRef = useRef(null);

//   const token = localStorage.getItem("adminToken");

//   // ---- helpers ----
//   const mapSort = (option) => {
//     // translate dropdown choice to {sortBy, sortDir}
//     switch (option) {
//       case "mostCommission":
//         return { sortBy: "commission", sortDir: "DESC" };
//       case "lowestCommission":
//         return { sortBy: "commission", sortDir: "ASC" };
//       case "topRating":
//         return { sortBy: "rating", sortDir: "DESC" };
//       case "lowRating":
//         return { sortBy: "rating", sortDir: "ASC" };
//       default:
//         return { sortBy: "id", sortDir: "ASC" };
//     }
//   };

//   const formatDateTime = (iso) => {
//     const d = new Date(iso);
//     const dateStr = d.toLocaleDateString("en-US", { day: "numeric", month: "long", year: "numeric" });
//     const [month, day, year] = dateStr.replace(",", "").split(" ");
//     const datePart = `${day}-${month}-${year}`;
//     const timeStr = d
//       .toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", second: "2-digit", hour12: true })
//       .toLowerCase();
//     return `${datePart}, ${timeStr}`;
//   };

//   // ---- fetch page ----
//   const fetchPage = async () => {
//     setLoading(true);
//     try {
//       const sort = mapSort(servitorFilter);
//       const { data } = await axios.get(`${URL}/admin/servitors/metrics`, {
//         headers: token ? { Authorization: `Bearer ${token}` } : undefined,
//         params: {
//           page: meta.page,
//           limit: meta.limit,
//           search: searchTerm,
//           serviceType: filterService === "All" ? "" : filterService,
//           sortBy: sort.sortBy, // id|name|orders|rating|commission|recharge|earnings
//           sortDir: sort.sortDir, // ASC|DESC
//         },
//       });

//       setServitors(Array.isArray(data?.data) ? data.data : []);
//       if (data?.meta) {
//         setMeta((m) => ({
//           ...m,
//           ...data.meta,
//           // keep our chosen page size if server echoes something else
//           limit: m.limit,
//         }));
//       }
//       setError(null);
//     } catch (err) {
//       console.error("Error fetching servitor metrics:", err);
//       setError("Failed to load servitor data. Please try again later.");
//       setServitors([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchPage();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [meta.page, meta.limit, searchTerm, servitorFilter, filterService, token]);

//   // pagination helpers
//   const handlePageChange = (pageNumber) => setMeta((m) => ({ ...m, page: pageNumber }));

//   const getPageItems = (total, current, maxButtons = 7) => {
//     const pages = [];
//     pages.push(1);
//     const siblings = Math.floor((maxButtons - 3) / 2);
//     let start = Math.max(2, current - siblings);
//     let end = Math.min(total - 1, current + siblings);

//     if (current <= siblings + 2) end = Math.min(total - 1, maxButtons - 1);
//     if (current >= total - (siblings + 1)) start = Math.max(2, total - (maxButtons - 2));

//     if (start > 2) pages.push("start-ellipsis");
//     for (let i = start; i <= end; i++) pages.push(i);
//     if (end < total - 1) pages.push("end-ellipsis");
//     if (total > 1) pages.push(total);
//     return pages;
//   };

//   // modal controls
//   const handleViewFeedbacks = async (row) => {
//     setSelectedServitor({ ...row, feedbacks: Array.isArray(row.feedbacks) ? row.feedbacks : [] });
//     setShowModal(true);
//     document.body.style.overflow = "hidden";

//     // fetch full feedback list on-demand (lighter list API)
//     try {
//       const { data } = await axios.get(`${URL}/admin/servitors/${row.id}/feedbacks`, {
//         headers: token ? { Authorization: `Bearer ${token}` } : undefined,
//       });
//       setSelectedServitor((r) => (r ? { ...r, feedbacks: Array.isArray(data) ? data : [] } : r));
//     } catch (e) {
//       // if endpoint not available, leave any preview data or empty list
//       console.warn("Feedback fetch failed:", e?.response?.data || e.message);
//     }
//   };
//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedServitor(null);
//     document.body.style.overflow = "auto";
//   };

//   useEffect(() => {
//     const node = modalRef.current;
//     const handleBackdropClick = (e) => node && e.target === node && handleCloseModal();
//     const handleEscapeKey = (e) => e.key === "Escape" && handleCloseModal();

//     if (node) node.addEventListener("click", handleBackdropClick);
//     document.addEventListener("keydown", handleEscapeKey);
//     return () => {
//       if (node) node.removeEventListener("click", handleBackdropClick);
//       document.removeEventListener("keydown", handleEscapeKey);
//     };
//   }, []);

//   // export all (page through backend)
//   const generatePDF = async () => {
//     try {
//       const sort = mapSort(servitorFilter);

//       // first page to know total pages (server cap is 100/req)
//       const first = await axios.get(`${URL}/admin/servitors/metrics`, {
//         headers: token ? { Authorization: `Bearer ${token}` } : undefined,
//         params: {
//           page: 1,
//           limit: 100,
//           search: searchTerm,
//           serviceType: filterService === "All" ? "" : filterService,
//           sortBy: sort.sortBy,
//           sortDir: sort.sortDir,
//         },
//       });

//       const all = [];
//       const totalPages = Math.max(1, first?.data?.meta?.totalPages || 1);
//       all.push(...(first?.data?.data || []));

//       for (let p = 2; p <= totalPages; p++) {
//         // eslint-disable-next-line no-await-in-loop
//         const { data } = await axios.get(`${URL}/admin/servitors/metrics`, {
//           headers: token ? { Authorization: `Bearer ${token}` } : undefined,
//           params: {
//             page: p,
//             limit: 100,
//             search: searchTerm,
//             serviceType: filterService === "All" ? "" : filterService,
//             sortBy: sort.sortBy,
//             sortDir: sort.sortDir,
//           },
//         });
//         all.push(...(data?.data || []));
//       }

//       if (all.length === 0) return;

//       const doc = new jsPDF();
//       doc.setFontSize(18);
//       doc.setFont("helvetica", "bold");
//       doc.text(`Servitor Report - ${filterService || "All Services"}`, 14, 20);
//       doc.setFontSize(10);
//       doc.setFont("helvetica", "normal");
//       const stamp = new Date().toLocaleString("en-US", {
//         day: "numeric",
//         month: "long",
//         year: "numeric",
//         hour: "numeric",
//         minute: "2-digit",
//         second: "2-digit",
//         hour12: true,
//       });
//       doc.text(`Generated on: ${stamp}`, 14, 30);

//       const hiddenTable = document.createElement("div");
//       hiddenTable.style.position = "absolute";
//       hiddenTable.style.left = "-9999px";
//       hiddenTable.innerHTML = `
//         <table class="adminServitorFeedbacks-table" style="width: 100%; border-collapse: collapse;">
//           <thead>
//             <tr>
//               <th>ID</th>
//               <th>Servitor Name</th>
//               <th>Mobile</th>
//               <th>Avg Rating</th>
//               <th>Commission</th>
//               <th>Complete Orders</th>
//               <th>Accepted Orders</th>
//               <th>Penalty</th>
//               <th>Order Cancelled</th>
//             </tr>
//           </thead>
//           <tbody>
//             ${all
//               .map(
//                 (s) => `
//               <tr>
//                 <td>${s.id ?? "-"}</td>
//                 <td>${s.name ?? "-"}</td>
//                 <td>${s.mobile ?? "-"}</td>
//                 <td>${s.rating ? Number(s.rating).toFixed(1) : "0"} / 5</td>
//                 <td>${s.commissionSum || 0}Tk</td>
//                 <td>${s.ordersCompleted || 0}</td>
//                 <td>${s.ordersAccepted || 0}</td>
//                 <td>${s.penaltySum || 0}</td>
//                 <td>${s.ordersCancelledByServitor || 0}</td>
//               </tr>`
//               )
//               .join("")}
//           </tbody>
//         </table>
//       `;
//       document.body.appendChild(hiddenTable);

//       const canvas = await html2canvas(hiddenTable, { scale: 2 });
//       document.body.removeChild(hiddenTable);

//       const imgData = canvas.toDataURL("image/png");
//       const imgWidth = 180; // mm
//       const pageHeight = 295; // A4 mm
//       const imgHeight = (canvas.height * imgWidth) / canvas.width;
//       let heightLeft = imgHeight;

//       doc.addImage(imgData, "PNG", 15, 40, imgWidth, imgHeight);
//       heightLeft -= pageHeight - 40;

//       while (heightLeft > 0) {
//         doc.addPage();
//         doc.addImage(imgData, "PNG", 15, 20, imgWidth, imgHeight);
//         heightLeft -= pageHeight - 20;
//       }

//       doc.save(`Servitor_Report_${filterService || "All"}_${new Date().toISOString().split("T")[0]}.pdf`);
//     } catch (e) {
//       console.error("Export failed:", e);
//     }
//   };

//   const renderFeedbackDetails = () => {
//     if (!selectedServitor) return null;

//     const {
//       name,
//       service,
//       rating,
//       ratingCount,
//       ordersCompleted,
//       ordersAccepted,
//       ordersCancelledByServitor,
//       totalEarnings,
//       commissionSum,
//       rechargeSum,
//       penaltySum,
//       feedbacks = [],
//     } = selectedServitor;

//     return (
//       <div className="adminServitorFeedbacks-modal">
//         <div className="adminServitorFeedbacks-modal-header">
//           <button className="adminServitorFeedbacks-modal-close" onClick={handleCloseModal}>
//             <FaTimes size={20} />
//           </button>
//           <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
//             <div className="adminServitorFeedbacks-service-icon">
//               <FaStar style={{ color: "#f59e0b" }} />
//             </div>
//             <div>
//               <h2 className="adminServitorFeedbacks-modal-title">Feedback for - {name}</h2>
//               <p className="adminServitorFeedbacks-modal-subtitle">
//                 {service} • {ratingCount || 0} Feedbacks
//               </p>
//             </div>
//           </div>
//         </div>

//         <div className="adminServitorFeedbacks-modal-body">
//           <div className="adminServitorFeedbacks-summary-cards">
//             <div className="adminServitorFeedbacks-summary-card adminServitorFeedbacks-rating-card">
//               <div>
//                 <p className="adminServitorFeedbacks-detail-text">Average Rating</p>
//                 <p className="adminServitorFeedbacks-rating-value">{rating ? Number(rating).toFixed(1) : 0} / 5</p>
//                 <div className="adminServitorFeedbacks-star-container">
//                   {[...Array(5)].map((_, index) => (
//                     <FaStar
//                       key={index}
//                       size={20}
//                       style={{ color: index < Math.round(Number(rating) || 0) ? "#f59e0b" : "#e5e7eb" }}
//                     />
//                   ))}
//                 </div>
//               </div>
//             </div>

//             <div className="adminServitorFeedbacks-summary-card adminServitorFeedbacks-completed-card">
//               <div>
//                 <p className="adminServitorFeedbacks-detail-text">Orders Completed</p>
//                 <p className="adminServitorFeedbacks-count-value">{ordersCompleted || 0}</p>
//               </div>
//               <FaCheckCircle size={24} style={{ color: "#22c55e" }} />
//             </div>
//             <div className="adminServitorFeedbacks-summary-card adminServitorFeedbacks-accepted-card">
//               <div>
//                 <p className="adminServitorFeedbacks-detail-text">Orders Accepted</p>
//                 <p className="adminServitorFeedbacks-count-value">{ordersAccepted || 0}</p>
//               </div>
//               <FaCheckCircle size={24} style={{ color: "#10b981" }} />
//             </div>
//             <div className="adminServitorFeedbacks-summary-card adminServitorFeedbacks-cancelled-card">
//               <div>
//                 <p className="adminServitorFeedbacks-detail-text">Orders Cancelled</p>
//                 <p className="adminServitorFeedbacks-count-value">{ordersCancelledByServitor || 0}</p>
//               </div>
//               <FaTimesCircle size={24} style={{ color: "#ef4444" }} />
//             </div>
//             <div className="adminServitorFeedbacks-summary-card adminServitorFeedbacks-earnings-card">
//               <div>
//                 <p className="adminServitorFeedbacks-detail-text">Total Earnings</p>
//                 <p className="adminServitorFeedbacks-price-value">৳{totalEarnings || 0}</p>
//               </div>
//             </div>
//             <div className="adminServitorFeedbacks-summary-card adminServitorFeedbacks-commission-card">
//               <div>
//                 <p className="adminServitorFeedbacks-detail-text">Commission</p>
//                 <p className="adminServitorFeedbacks-price-value">৳{commissionSum || 0}</p>
//               </div>
//             </div>
//             <div className="adminServitorFeedbacks-summary-card adminServitorFeedbacks-recharge-card">
//               <div>
//                 <p className="adminServitorFeedbacks-detail-text">Recharge Amount</p>
//                 <p className="adminServitorFeedbacks-price-value">৳{rechargeSum || 0}</p>
//               </div>
//             </div>
//             <div className="adminServitorFeedbacks-summary-card adminServitorFeedbacks-penalty-card">
//               <div>
//                 <p className="adminServitorFeedbacks-detail-text">Penalties</p>
//                 <p className="adminServitorFeedbacks-count-value">৳{penaltySum || 0}</p>
//               </div>
//               <FaTimesCircle size={24} style={{ color: "#ef4444" }} />
//             </div>
//           </div>

//           <div className="adminServitorFeedbacks-detail-card">
//             <h3 className="adminServitorFeedbacks-detail-title">
//               <FaStar style={{ marginRight: "8px", color: "#f59e0b" }} />
//               Feedback List
//             </h3>
//             <div className="adminServitorFeedbacks-feedback-list">
//               {!feedbacks || feedbacks.length === 0 ? (
//                 <p className="adminServitorFeedbacks-detail-value">No feedback available.</p>
//               ) : (
//                 feedbacks.map((f) => (
//                   <div key={`${f.order_number}-${f.transactionDate}`} className="adminServitorFeedbacks-feedback-item">
//                     <div className="adminServitorFeedbacks-feedback-header">
//                       <span className="adminServitorFeedbacks-feedback-id">Feedback of order #{f.order_number}</span>
//                     </div>
//                     <div className="adminServitorFeedbacks-feedback-rating">
//                       <span>Rating:</span>
//                       <div className="adminServitorFeedbacks-star-container">
//                         {[...Array(5)].map((_, index) => (
//                           <FaStar key={index} size={16} style={{ color: index < (f.rating || 0) ? "#f59e0b" : "#e5e7eb" }} />
//                         ))}
//                       </div>
//                     </div>
//                     <p className="adminServitorFeedbacks-feedback-comment">{f.feedback}</p>
//                     <p className="adminServitorFeedbacks-feedback-date">{formatDateTime(f.transactionDate)}</p>
//                     <hr className="adminServitorFeedbacks-rating-underline" />
//                   </div>
//                 ))
//               )}
//             </div>
//           </div>
//         </div>

//         <div className="adminServitorFeedbacks-modal-footer">
//           <div className="adminServitorFeedbacks-footer-buttons">
//             <button className="adminServitorFeedbacks-footer-btn adminServitorFeedbacks-footer-btn-close" onClick={handleCloseModal}>
//               <FaCheck />
//               Close
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <Container fluid className="adminServitorFeedbacks-container">
//       <Card className="adminServitorFeedbacks-card">
//         <Card.Body>
//           <Card.Header className="adminServitorFeedbacks-header">
//             <h4 className="adminServitorFeedbacks-title">Servitor Feedbacks &amp; Details</h4>
//           </Card.Header>

//           {error && <div className="adminServitorFeedbacks-error">{error}</div>}

//           <Row className="mb-3">
//             <Col md={8}>
//               <InputGroup>
//                 <Form.Control
//                   type="text"
//                   placeholder="Search by Servitor ID, Name or Mobile (mobile without leading 0)"
//                   value={searchTerm}
//                   onChange={(e) => {
//                     setSearchTerm(e.target.value);
//                     setMeta((m) => ({ ...m, page: 1 }));
//                   }}
//                   className="adminServitorFeedbacks-search"
//                 />
//               </InputGroup>
//             </Col>
//             <Col md={4}>
//               <Form.Group controlId="serviceSort">
//                 <Form.Select
//                   value={servitorFilter}
//                   onChange={(e) => {
//                     setServitorFilter(e.target.value);
//                     setMeta((m) => ({ ...m, page: 1 }));
//                   }}
//                   className="adminServitorFeedbacks-filter-select"
//                 >
//                   <option value="">— Sort Servitors —</option>
//                   <option value="mostCommission">Most Commission</option>
//                   <option value="topRating">Top Rating</option>
//                   <option value="lowestCommission">Lowest Commission</option>
//                   <option value="lowRating">Low Rating</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>

//           <div className="adminServitorFeedbacks-filter-container">
//             <div className="adminServitorFeedbacks-service-filters">
//               {["All", "Electrician", "Home Cleaning", "Plumber", "Gas Chula", "AC Service", "Filter", "Tutor Service"].map(
//                 (service) => (
//                   <Button
//                     key={service}
//                     variant={filterService === service ? "primary" : "outline-primary"}
//                     className="adminServitorFeedbacks-filter-btn"
//                     onClick={() => {
//                       setFilterService(service);
//                       setMeta((m) => ({ ...m, page: 1 }));
//                     }}
//                   >
//                     {service}
//                   </Button>
//                 )
//               )}
//             </div>

//             <div className="adminServitorFeedbacks-export-container">
//               <button onClick={generatePDF} className="adminServitorFeedbacks-footer-btn adminServitorFeedbacks-export-btn" disabled={loading}>
//                 <FaCheck />
//                 Export to PDF
//               </button>
//             </div>
//           </div>

//           <Table striped bordered hover responsive className="adminServitorFeedbacks-table" ref={tableRef}>
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Servitor ID</th>
//                 <th>Mobile</th>
//                 <th>Name</th>
//                 <th>Service</th>
//                 <th>Avg Rating</th>
//                 <th>Commission</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {servitors.map((s, index) => (
//                 <tr key={s.id}>
//                   <td>{index + 1 + (meta.page - 1) * meta.limit}</td>
//                   <td>{s.id}</td>
//                   <td>{s.mobile}</td>
//                   <td>{s.name}</td>
//                   <td>{s.service}</td>
//                   <td>
//                     <Badge className="adminServitorFeedbacks-rating-badge">
//                       {s.rating ? Number(s.rating).toFixed(1) : 0} / 5
//                       <div className="adminServitorFeedbacks-star-container">
//                         {[...Array(5)].map((_, idx) => (
//                           <FaStar
//                             key={idx}
//                             size={14}
//                             style={{ color: idx < Math.round(Number(s.rating) || 0) ? "#f59e0b" : "#e5e7eb" }}
//                           />
//                         ))}
//                       </div>
//                     </Badge>
//                   </td>
//                   <td>৳{s.commissionSum || 0}</td>
//                   <td>
//                     <Button
//                       variant="outline-primary"
//                       size="sm"
//                       className="adminServitorFeedbacks-action-btn"
//                       onClick={() => handleViewFeedbacks(s)}
//                     >
//                       <BsEye size={16} />
//                     </Button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>

//           <Pagination>
//             <Pagination.First onClick={() => handlePageChange(1)} disabled={meta.page === 1} />
//             <Pagination.Prev onClick={() => handlePageChange(meta.page - 1)} disabled={meta.page === 1} />
//             {getPageItems(meta.totalPages, meta.page).map((item, idx) => {
//               if (item === "start-ellipsis" || item === "end-ellipsis") {
//                 return <Pagination.Ellipsis key={item + idx} disabled />;
//               }
//               return (
//                 <Pagination.Item key={item} active={item === meta.page} onClick={() => handlePageChange(item)}>
//                   {item}
//                 </Pagination.Item>
//               );
//             })}
//             <Pagination.Next onClick={() => handlePageChange(meta.page + 1)} disabled={meta.page === meta.totalPages} />
//             <Pagination.Last onClick={() => handlePageChange(meta.totalPages)} disabled={meta.page === meta.totalPages} />
//           </Pagination>
//         </Card.Body>
//       </Card>

//       {showModal && (
//         <div className="adminServitorFeedbacks-modal-backdrop" ref={modalRef}>
//           {renderFeedbackDetails()}
//         </div>
//       )}
//     </Container>
//   );
// };

// export default ServitorFeedbackList;






// ***** Upper code is okay just updated with auth protect (2-Dec-2025) ***** //
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import {
  Table,
  Container,
  Card,
  Pagination,
  Badge,
  Button,
  InputGroup,
  Form,
  Row,
  Col,
} from "react-bootstrap";
import { BsEye } from "react-icons/bs";
import { FaTimes, FaStar, FaCheck, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import "./ServitorFeedbackList.css";
import { URL } from "../../../config";

const DEFAULT_LIMIT = 10;

const ServitorFeedbackList = () => {
  // server data
  const [servitors, setServitors] = useState([]);
  const [meta, setMeta] = useState({
    page: 1,
    limit: DEFAULT_LIMIT,
    total: 0,
    totalPages: 1,
    search: "",
    serviceType: "All",
    sortBy: "id",
    sortDir: "ASC",
  });

  // ui state
  const [searchTerm, setSearchTerm] = useState("");
  const [servitorFilter, setServitorFilter] = useState(""); // mostCommission | topRating | lowestCommission | lowRating
  const [filterService, setFilterService] = useState("All");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // modal
  const [selectedServitor, setSelectedServitor] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const modalRef = useRef(null);
  const tableRef = useRef(null);

  // ---- helpers ----
  const mapSort = (option) => {
    // translate dropdown choice to {sortBy, sortDir}
    switch (option) {
      case "mostCommission":
        return { sortBy: "commission", sortDir: "DESC" };
      case "lowestCommission":
        return { sortBy: "commission", sortDir: "ASC" };
      case "topRating":
        return { sortBy: "rating", sortDir: "DESC" };
      case "lowRating":
        return { sortBy: "rating", sortDir: "ASC" };
      default:
        return { sortBy: "id", sortDir: "ASC" };
    }
  };

  const formatDateTime = (iso) => {
    const d = new Date(iso);
    const dateStr = d.toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    const [month, day, year] = dateStr.replace(",", "").split(" ");
    const datePart = `${day}-${month}-${year}`;
    const timeStr = d
      .toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      })
      .toLowerCase();
    return `${datePart}, ${timeStr}`;
  };

  // ---- fetch page ----
  const fetchPage = async () => {
    setLoading(true);
    try {
      const sort = mapSort(servitorFilter);
      const adminToken = localStorage.getItem("adminToken");

      const { data } = await axios.get(`${URL}/admin/servitors/metrics`, {
        headers: adminToken ? { Authorization: `Bearer ${adminToken}` } : {},
        params: {
          page: meta.page,
          limit: meta.limit,
          search: searchTerm,
          serviceType: filterService === "All" ? "" : filterService,
          sortBy: sort.sortBy, // id|name|orders|rating|commission|recharge|earnings
          sortDir: sort.sortDir, // ASC|DESC
        },
      });

      setServitors(Array.isArray(data?.data) ? data.data : []);
      if (data?.meta) {
        setMeta((m) => ({
          ...m,
          ...data.meta,
          // keep our chosen page size if server echoes something else
          limit: m.limit,
        }));
      }
      setError(null);
    } catch (err) {
      console.error("Error fetching servitor metrics:", err);
      setError("Failed to load servitor data. Please try again later.");
      setServitors([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meta.page, meta.limit, searchTerm, servitorFilter, filterService]);

  // pagination helpers
  const handlePageChange = (pageNumber) =>
    setMeta((m) => ({ ...m, page: pageNumber }));

  const getPageItems = (total, current, maxButtons = 7) => {
    const pages = [];
    pages.push(1);
    const siblings = Math.floor((maxButtons - 3) / 2);
    let start = Math.max(2, current - siblings);
    let end = Math.min(total - 1, current + siblings);

    if (current <= siblings + 2) end = Math.min(total - 1, maxButtons - 1);
    if (current >= total - (siblings + 1))
      start = Math.max(2, total - (maxButtons - 2));

    if (start > 2) pages.push("start-ellipsis");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < total - 1) pages.push("end-ellipsis");
    if (total > 1) pages.push(total);
    return pages;
  };

  // modal controls
  const handleViewFeedbacks = async (row) => {
    setSelectedServitor({
      ...row,
      feedbacks: Array.isArray(row.feedbacks) ? row.feedbacks : [],
    });
    setShowModal(true);
    document.body.style.overflow = "hidden";

    // fetch full feedback list on-demand (lighter list API)
    try {
      const adminToken = localStorage.getItem("adminToken");

      const { data } = await axios.get(
        `${URL}/admin/servitors/${row.id}/feedbacks`,
        {
          headers: adminToken ? { Authorization: `Bearer ${adminToken}` } : {},
        }
      );
      setSelectedServitor((r) =>
        r ? { ...r, feedbacks: Array.isArray(data) ? data : [] } : r
      );
    } catch (e) {
      // if endpoint not available, leave any preview data or empty list
      console.warn("Feedback fetch failed:", e?.response?.data || e.message);
    }
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedServitor(null);
    document.body.style.overflow = "auto";
  };

  useEffect(() => {
    const node = modalRef.current;
    const handleBackdropClick = (e) =>
      node && e.target === node && handleCloseModal();
    const handleEscapeKey = (e) => e.key === "Escape" && handleCloseModal();

    if (node) node.addEventListener("click", handleBackdropClick);
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      if (node) node.removeEventListener("click", handleBackdropClick);
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, []);

  // export all (page through backend)
  const generatePDF = async () => {
    try {
      const sort = mapSort(servitorFilter);
      const adminToken = localStorage.getItem("adminToken");

      // first page to know total pages (server cap is 100/req)
      const first = await axios.get(`${URL}/admin/servitors/metrics`, {
        headers: adminToken ? { Authorization: `Bearer ${adminToken}` } : {},
        params: {
          page: 1,
          limit: 100,
          search: searchTerm,
          serviceType: filterService === "All" ? "" : filterService,
          sortBy: sort.sortBy,
          sortDir: sort.sortDir,
        },
      });

      const all = [];
      const totalPages = Math.max(1, first?.data?.meta?.totalPages || 1);
      all.push(...(first?.data?.data || []));

      for (let p = 2; p <= totalPages; p++) {
        // eslint-disable-next-line no-await-in-loop
        const { data } = await axios.get(`${URL}/admin/servitors/metrics`, {
          headers: adminToken ? { Authorization: `Bearer ${adminToken}` } : {},
          params: {
            page: p,
            limit: 100,
            search: searchTerm,
            serviceType: filterService === "All" ? "" : filterService,
            sortBy: sort.sortBy,
            sortDir: sort.sortDir,
          },
        });
        all.push(...(data?.data || []));
      }

      if (all.length === 0) return;

      const doc = new jsPDF();
      doc.setFontSize(18);
      doc.setFont("helvetica", "bold");
      doc.text(
        `Servitor Report - ${filterService || "All Services"}`,
        14,
        20
      );
      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      const stamp = new Date().toLocaleString("en-US", {
        day: "numeric",
        month: "long",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });
      doc.text(`Generated on: ${stamp}`, 14, 30);

      const hiddenTable = document.createElement("div");
      hiddenTable.style.position = "absolute";
      hiddenTable.style.left = "-9999px";
      hiddenTable.innerHTML = `
        <table class="adminServitorFeedbacks-table" style="width: 100%; border-collapse: collapse;">
          <thead>
            <tr>
              <th>ID</th>
              <th>Servitor Name</th>
              <th>Mobile</th>
              <th>Avg Rating</th>
              <th>Commission</th>
              <th>Complete Orders</th>
              <th>Accepted Orders</th>
              <th>Penalty</th>
              <th>Order Cancelled</th>
            </tr>
          </thead>
          <tbody>
            ${all
              .map(
                (s) => `
              <tr>
                <td>${s.id ?? "-"}</td>
                <td>${s.name ?? "-"}</td>
                <td>${s.mobile ?? "-"}</td>
                <td>${s.rating ? Number(s.rating).toFixed(1) : "0"} / 5</td>
                <td>${s.commissionSum || 0}Tk</td>
                <td>${s.ordersCompleted || 0}</td>
                <td>${s.ordersAccepted || 0}</td>
                <td>${s.penaltySum || 0}</td>
                <td>${s.ordersCancelledByServitor || 0}</td>
              </tr>`
              )
              .join("")}
          </tbody>
        </table>
      `;
      document.body.appendChild(hiddenTable);

      const canvas = await html2canvas(hiddenTable, { scale: 2 });
      document.body.removeChild(hiddenTable);

      const imgData = canvas.toDataURL("image/png");
      const imgWidth = 180; // mm
      const pageHeight = 295; // A4 mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;

      doc.addImage(imgData, "PNG", 15, 40, imgWidth, imgHeight);
      heightLeft -= pageHeight - 40;

      while (heightLeft > 0) {
        doc.addPage();
        doc.addImage(imgData, "PNG", 15, 20, imgWidth, imgHeight);
        heightLeft -= pageHeight - 20;
      }

      doc.save(
        `Servitor_Report_${filterService || "All"}_${
          new Date().toISOString().split("T")[0]
        }.pdf`
      );
    } catch (e) {
      console.error("Export failed:", e);
    }
  };

  const renderFeedbackDetails = () => {
    if (!selectedServitor) return null;

    const {
      name,
      service,
      rating,
      ratingCount,
      ordersCompleted,
      ordersAccepted,
      ordersCancelledByServitor,
      totalEarnings,
      commissionSum,
      rechargeSum,
      penaltySum,
      feedbacks = [],
    } = selectedServitor;

    return (
      <div className="adminServitorFeedbacks-modal">
        <div className="adminServitorFeedbacks-modal-header">
          <button
            className="adminServitorFeedbacks-modal-close"
            onClick={handleCloseModal}
          >
            <FaTimes size={20} />
          </button>
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <div className="adminServitorFeedbacks-service-icon">
              <FaStar style={{ color: "#f59e0b" }} />
            </div>
            <div>
              <h2 className="adminServitorFeedbacks-modal-title">
                Feedback for - {name}
              </h2>
              <p className="adminServitorFeedbacks-modal-subtitle">
                {service} • {ratingCount || 0} Feedbacks
              </p>
            </div>
          </div>
        </div>

        <div className="adminServitorFeedbacks-modal-body">
          <div className="adminServitorFeedbacks-summary-cards">
            <div className="adminServitorFeedbacks-summary-card adminServitorFeedbacks-rating-card">
              <div>
                <p className="adminServitorFeedbacks-detail-text">
                  Average Rating
                </p>
                <p className="adminServitorFeedbacks-rating-value">
                  {rating ? Number(rating).toFixed(1) : 0} / 5
                </p>
                <div className="adminServitorFeedbacks-star-container">
                  {[...Array(5)].map((_, index) => (
                    <FaStar
                      key={index}
                      size={20}
                      style={{
                        color:
                          index < Math.round(Number(rating) || 0)
                            ? "#f59e0b"
                            : "#e5e7eb",
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>

            <div className="adminServitorFeedbacks-summary-card adminServitorFeedbacks-completed-card">
              <div>
                <p className="adminServitorFeedbacks-detail-text">
                  Orders Completed
                </p>
                <p className="adminServitorFeedbacks-count-value">
                  {ordersCompleted || 0}
                </p>
              </div>
              <FaCheckCircle size={24} style={{ color: "#22c55e" }} />
            </div>
            <div className="adminServitorFeedbacks-summary-card adminServitorFeedbacks-accepted-card">
              <div>
                <p className="adminServitorFeedbacks-detail-text">
                  Orders Accepted
                </p>
                <p className="adminServitorFeedbacks-count-value">
                  {ordersAccepted || 0}
                </p>
              </div>
              <FaCheckCircle size={24} style={{ color: "#10b981" }} />
            </div>
            <div className="adminServitorFeedbacks-summary-card adminServitorFeedbacks-cancelled-card">
              <div>
                <p className="adminServitorFeedbacks-detail-text">
                  Orders Cancelled
                </p>
                <p className="adminServitorFeedbacks-count-value">
                  {ordersCancelledByServitor || 0}
                </p>
              </div>
              <FaTimesCircle size={24} style={{ color: "#ef4444" }} />
            </div>
            <div className="adminServitorFeedbacks-summary-card adminServitorFeedbacks-earnings-card">
              <div>
                <p className="adminServitorFeedbacks-detail-text">
                  Total Earnings
                </p>
                <p className="adminServitorFeedbacks-price-value">
                  ৳{totalEarnings || 0}
                </p>
              </div>
            </div>
            <div className="adminServitorFeedbacks-summary-card adminServitorFeedbacks-commission-card">
              <div>
                <p className="adminServitorFeedbacks-detail-text">
                  Commission
                </p>
                <p className="adminServitorFeedbacks-price-value">
                  ৳{commissionSum || 0}
                </p>
              </div>
            </div>
            <div className="adminServitorFeedbacks-summary-card adminServitorFeedbacks-recharge-card">
              <div>
                <p className="adminServitorFeedbacks-detail-text">
                  Recharge Amount
                </p>
                <p className="adminServitorFeedbacks-price-value">
                  ৳{rechargeSum || 0}
                </p>
              </div>
            </div>
            <div className="adminServitorFeedbacks-summary-card adminServitorFeedbacks-penalty-card">
              <div>
                <p className="adminServitorFeedbacks-detail-text">Penalties</p>
                <p className="adminServitorFeedbacks-count-value">
                  ৳{penaltySum || 0}
                </p>
              </div>
              <FaTimesCircle size={24} style={{ color: "#ef4444" }} />
            </div>
          </div>

          <div className="adminServitorFeedbacks-detail-card">
            <h3 className="adminServitorFeedbacks-detail-title">
              <FaStar style={{ marginRight: "8px", color: "#f59e0b" }} />
              Feedback List
            </h3>
            <div className="adminServitorFeedbacks-feedback-list">
              {!feedbacks || feedbacks.length === 0 ? (
                <p className="adminServitorFeedbacks-detail-value">
                  No feedback available.
                </p>
              ) : (
                feedbacks.map((f) => (
                  <div
                    key={`${f.order_number}-${f.transactionDate}`}
                    className="adminServitorFeedbacks-feedback-item"
                  >
                    <div className="adminServitorFeedbacks-feedback-header">
                      <span className="adminServitorFeedbacks-feedback-id">
                        Feedback of order #{f.order_number}
                      </span>
                    </div>
                    <div className="adminServitorFeedbacks-feedback-rating">
                      <span>Rating:</span>
                      <div className="adminServitorFeedbacks-star-container">
                        {[...Array(5)].map((_, index) => (
                          <FaStar
                            key={index}
                            size={16}
                            style={{
                              color:
                                index < (f.rating || 0)
                                  ? "#f59e0b"
                                  : "#e5e7eb",
                            }}
                          />
                        ))}
                      </div>
                    </div>
                    <p className="adminServitorFeedbacks-feedback-comment">
                      {f.feedback}
                    </p>
                    <p className="adminServitorFeedbacks-feedback-date">
                      {formatDateTime(f.transactionDate)}
                    </p>
                    <hr className="adminServitorFeedbacks-rating-underline" />
                  </div>
                ))
              )}
            </div>
          </div>
        </div>

        <div className="adminServitorFeedbacks-modal-footer">
          <div className="adminServitorFeedbacks-footer-buttons">
            <button
              className="adminServitorFeedbacks-footer-btn adminServitorFeedbacks-footer-btn-close"
              onClick={handleCloseModal}
            >
              <FaCheck />
              Close
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Container fluid className="adminServitorFeedbacks-container">
      <Card className="adminServitorFeedbacks-card">
        <Card.Body>
          <Card.Header className="adminServitorFeedbacks-header">
            <h4 className="adminServitorFeedbacks-title">
              Servitor Feedbacks &amp; Details
            </h4>
          </Card.Header>

          {error && (
            <div className="adminServitorFeedbacks-error">{error}</div>
          )}

          <Row className="mb-3">
            <Col md={8}>
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Search by Servitor ID, Name or Mobile (mobile without leading 0)"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setMeta((m) => ({ ...m, page: 1 }));
                  }}
                  className="adminServitorFeedbacks-search"
                />
              </InputGroup>
            </Col>
            <Col md={4}>
              <Form.Group controlId="serviceSort">
                <Form.Select
                  value={servitorFilter}
                  onChange={(e) => {
                    setServitorFilter(e.target.value);
                    setMeta((m) => ({ ...m, page: 1 }));
                  }}
                  className="adminServitorFeedbacks-filter-select"
                >
                  <option value="">— Sort Servitors —</option>
                  <option value="mostCommission">Most Commission</option>
                  <option value="topRating">Top Rating</option>
                  <option value="lowestCommission">Lowest Commission</option>
                  <option value="lowRating">Low Rating</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <div className="adminServitorFeedbacks-filter-container">
            <div className="adminServitorFeedbacks-service-filters">
              {[
                "All",
                "Electrician",
                "Home Cleaning",
                "Plumber",
                "Gas Chula",
                "AC Service",
                "Filter",
                "Tutor Service",
              ].map((service) => (
                <Button
                  key={service}
                  variant={
                    filterService === service ? "primary" : "outline-primary"
                  }
                  className="adminServitorFeedbacks-filter-btn"
                  onClick={() => {
                    setFilterService(service);
                    setMeta((m) => ({ ...m, page: 1 }));
                  }}
                >
                  {service}
                </Button>
              ))}
            </div>

            <div className="adminServitorFeedbacks-export-container">
              <button
                onClick={generatePDF}
                className="adminServitorFeedbacks-footer-btn adminServitorFeedbacks-export-btn"
                disabled={loading}
              >
                <FaCheck />
                Export to PDF
              </button>
            </div>
          </div>

          <Table
            striped
            bordered
            hover
            responsive
            className="adminServitorFeedbacks-table"
            ref={tableRef}
          >
            <thead>
              <tr>
                <th>#</th>
                <th>Servitor ID</th>
                <th>Mobile</th>
                <th>Name</th>
                <th>Service</th>
                <th>Avg Rating</th>
                <th>Commission</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {servitors.map((s, index) => (
                <tr key={s.id}>
                  <td>{index + 1 + (meta.page - 1) * meta.limit}</td>
                  <td>{s.id}</td>
                  <td>{s.mobile}</td>
                  <td>{s.name}</td>
                  <td>{s.service}</td>
                  <td>
                    <Badge className="adminServitorFeedbacks-rating-badge">
                      {s.rating ? Number(s.rating).toFixed(1) : 0} / 5
                      <div className="adminServitorFeedbacks-star-container">
                        {[...Array(5)].map((_, idx) => (
                          <FaStar
                            key={idx}
                            size={14}
                            style={{
                              color:
                                idx <
                                Math.round(Number(s.rating) || 0)
                                  ? "#f59e0b"
                                  : "#e5e7eb",
                            }}
                          />
                        ))}
                      </div>
                    </Badge>
                  </td>
                  <td>৳{s.commissionSum || 0}</td>
                  <td>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      className="adminServitorFeedbacks-action-btn"
                      onClick={() => handleViewFeedbacks(s)}
                    >
                      <BsEye size={16} />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <Pagination>
            <Pagination.First
              onClick={() => handlePageChange(1)}
              disabled={meta.page === 1}
            />
            <Pagination.Prev
              onClick={() => handlePageChange(meta.page - 1)}
              disabled={meta.page === 1}
            />
            {getPageItems(meta.totalPages, meta.page).map((item, idx) => {
              if (item === "start-ellipsis" || item === "end-ellipsis") {
                return <Pagination.Ellipsis key={item + idx} disabled />;
              }
              return (
                <Pagination.Item
                  key={item}
                  active={item === meta.page}
                  onClick={() => handlePageChange(item)}
                >
                  {item}
                </Pagination.Item>
              );
            })}
            <Pagination.Next
              onClick={() => handlePageChange(meta.page + 1)}
              disabled={meta.page === meta.totalPages}
            />
            <Pagination.Last
              onClick={() => handlePageChange(meta.totalPages)}
              disabled={meta.page === meta.totalPages}
            />
          </Pagination>
        </Card.Body>
      </Card>

      {showModal && (
        <div
          className="adminServitorFeedbacks-modal-backdrop"
          ref={modalRef}
        >
          {renderFeedbackDetails()}
        </div>
      )}
    </Container>
  );
};

export default ServitorFeedbackList;
